<template>
  <div class="notification-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span>通知管理</span>
        <el-button type="primary" size="small" @click="handleCreate">新增通知</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="message" label="内容" min-width="260">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.message"
              placement="top"
              :open-delay="300"
            >
              <span class="message-text">{{ scope.row.message }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="isNotified" label="启用" width="120">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.isNotified"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用"
              @change="handleToggle(scope.row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="内容" prop="message">
          <el-input
            v-model="form.message"
            type="textarea"
            :rows="4"
            placeholder="请输入通知内容"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="启用状态" prop="isNotified">
          <el-switch v-model="form.isNotified" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/utils/http'

function toViewNotification (item) {
  return {
    id: item.id,
    message: item.message || '',
    isNotified: item.isNotified === 1 ? 1 : 0
  }
}

export default {
  name: 'NotificationManage',
  data () {
    return {
      loading: false,
      list: [],
      dialogVisible: false,
      dialogTitle: '新增通知',
      form: {
        id: null,
        message: '',
        isNotified: 1
      },
      rules: {
        message: [{ required: true, message: '请输入通知内容', trigger: 'blur' }],
        isNotified: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const res = await http.get('/api/notifications')
        let items = []
        if (Array.isArray(res)) {
          items = res
        } else if (res && Array.isArray(res.data)) {
          items = res.data
        } else if (res && Array.isArray(res.items)) {
          items = res.items
        } else {
          items = []
        }
        this.list = items.map(toViewNotification)
      } catch (e) {
        this.$message.error(e.message || '获取通知列表失败')
      } finally {
        this.loading = false
      }
    },
    handleCreate () {
      this.dialogTitle = '新增通知'
      this.dialogVisible = true
      this.form = {
        id: null,
        message: '',
        isNotified: 1
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    handleEdit (row) {
      this.dialogTitle = '编辑通知'
      this.dialogVisible = true
      this.form = { ...row }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    handleSubmit () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const payload = {
          message: this.form.message,
          isNotified: this.form.isNotified
        }
        try {
          if (this.form.id) {
            await http.put(`/api/notifications/${this.form.id}`, payload)
          } else {
            await http.post('/api/notifications', payload)
          }
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '保存失败')
        }
      })
    },
    async handleDelete (row) {
      try {
        await this.$confirm(`确认删除该通知吗？`, '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        await http.delete(`/api/notifications/${row.id}`)
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '删除失败')
      }
    },
    async handleToggle (row, target) {
      const prev = row.isNotified
      row.isNotified = target
      try {
        await http.put(`/api/notifications/${row.id}`, {
          message: row.message,
          isNotified: target
        })
        this.$message.success('状态更新成功')
      } catch (e) {
        row.isNotified = prev
        this.$message.error(e.message || '状态更新失败')
      }
    }
  }
}
</script>

<style scoped>
.notification-manage {
  min-height: 300px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message-text {
  display: inline-block;
  max-width: 380px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>

